
@switch (name) {
  @case (enclosureTypeConstants.PRISMA_XS) {
    <ng-container i18n="@@app.prisma_xs">Prisma XS</ng-container>
  }
  @default {
    {{name}}
  }
}
